import { useQuery } from '@tanstack/react-query'
import { useDebounced } from '@/hooks/use-debounced'
import { type SearchContentResponse, searchCaseContent } from '@/services/api/case-search'

export function useContentSearch(caseId: string | undefined, query: string) {
  const debounced = useDebounced(query, 200)
  const enabled = Boolean(caseId) && debounced.trim().length >= 2

  return useQuery<SearchContentResponse>({
    queryKey: ['case-content-search', caseId, debounced],
    queryFn: () => searchCaseContent(caseId!, debounced),
    enabled,
    staleTime: 30_000,
  })
}
